<template>
    <img
        class="my-auto photo ui image"
        :id="'card_' + photo.id"
        :src="photoSrc"
        @mousedown="start"
        @mouseleave="stop"
        @mouseup="stop"
        @touchstart="start"
        @touchend="stop"
        @touchcancel="stop"
        @click.stop="$emit('gallery', photo.id)"
    >
</template>
<style type="text/css" scoped>
.photo {
    border: 3px solid transparent !important;
    width: 140px !important;
}
.selected {
    border: 3px solid lightcoral !important;
}
</style>
<script type="text/javascript">
export default {
    props: {
        photo: {
            required: false
        },
        index: {
            required: false
        }
    },
    data() {
        return {
            interval: false,
            count: 0,
            photoSrc: null,
            fullPhoto: null
        };
    },
    methods: {
        url(id) {
            return "/photos/" + id + "/thumb";
        },
        start() {
            if (!this.interval) {
                this.interval = setInterval(() => {
                    this.count++;
                    if (this.count >= 15) {
                        $("#card_" + this.photo.id).classList.toggle(
                            "selected"
                        );
                        this.count = 0;
                        clearInterval(this.interval);
                        this.interval = false;
                        this.$emit("selected", this.photo.id);
                    }
                }, 30);
            }
        },
        stop() {
            clearInterval(this.interval);
            this.interval = false;
            this.count == 0;
        }
    },
    mounted() {
        this.$store
            .dispatch("photo/THUMB", this.photo.id)
            .then(data => (this.photoSrc = data));
    }
};
</script>
